module.exports = __webpack_public_path__ + "static/img/线下活动-发布会or晚会.533b6d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10011/线下活动-发布会or晚会.png
// module id = QhRs
// module chunks = 1